import { ManualCrawlerState } from 'src/react/manualCrawler/state/ManualCrawlerState';

export const MANUAL_CRAWLER_DEFAULT_STATE: ManualCrawlerState = {
    crawlerTask: null,
    progress: null,
    fetchedUrls: [],
    loading: false,
    error: null,
};
